import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";

/**
 * Footer — brand-green background (#6B996C) with white typography
 * and charcoal (#1A1C1A / brand-dark) used as an accent color for links
 * on hover and section dividers.
 */
export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="mt-24 text-white"
      style={{ backgroundColor: "#6B996C" }}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-10 md:py-12 grid md:grid-cols-12 gap-8">
        <div className="md:col-span-7 md:self-center">
          <img
            src="/brand/island-studio-logo-white.png"
            alt="The Island Studio · Nassau, The Bahamas"
            className="h-16 md:h-20 w-auto object-contain object-left"
          />
          <p className="mt-4 text-white/85 leading-relaxed max-w-md text-sm">
            Bringing a little more Bahamas home — Dedicated to creating paper goods
            that people are proud to give, keep, and collect.
          </p>
        </div>

        <div className="md:col-span-5 md:text-right">
          <p
            className="text-[10px] tracking-[0.22em] uppercase font-medium"
            style={{ color: "#1A1C1A" }}
          >
            Studio
          </p>
          <ul className="mt-3 space-y-1.5 text-sm">
            <li><Link to="/about" className="text-white hover:text-[#1A1C1A] transition-colors">About</Link></li>
            <li><Link to="/services" className="text-white hover:text-[#1A1C1A] transition-colors">Services</Link></li>
            <li><Link to="/wholesale" className="text-white hover:text-[#1A1C1A] transition-colors">Wholesale</Link></li>
            <li><Link to="/faq" className="text-white hover:text-[#1A1C1A] transition-colors">FAQ</Link></li>
            <li><Link to="/quote" className="text-white hover:text-[#1A1C1A] transition-colors">Get a Quote</Link></li>
          </ul>

          <div className="mt-5 flex items-center gap-4 text-white md:justify-end">
            <a
              data-testid="footer-instagram"
              href="https://instagram.com/theislandstudio242"
              target="_blank"
              rel="noreferrer"
              className="text-white hover:text-[#1A1C1A] transition-colors"
              aria-label="Instagram — @theislandstudio242"
            >
              <Instagram strokeWidth={1.5} className="w-5 h-5" />
            </a>
            <a
              data-testid="footer-email"
              href="mailto:theislandstudio242@gmail.com"
              className="text-white hover:text-[#1A1C1A] transition-colors"
              aria-label="Email — theislandstudio242@gmail.com"
            >
              <Mail strokeWidth={1.5} className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>

      <div style={{ borderTop: "1px solid rgba(26,28,26,0.35)" }}>
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-4 text-center text-[11px] uppercase tracking-widest">
          <p className="text-white/85">© {new Date().getFullYear()} The Island Studio. Made in The Bahamas.</p>
        </div>
      </div>
    </footer>
  );
}
